import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
    MDBAlert,
    MDBBtn,
    MDBIcon,
    MDBModalFooter,
    MDBSpinner,
} from "mdb-react-ui-kit";
import { useLocation, useNavigate } from "react-router";
import { getMisc, removeUserLocation } from "../../../apiclients/streamsapi_bridge";
import { getGlobalLocation } from "../../LoginNext";
import AddNineOneOneLocation from "./Add911Location";
import PopupLoaderNew from "../PopupLoaderNew";

function RemoveLocations(props) {
    const toggleShow23 = () => setRemoveLocation(!RemoveLocation);
    const [RemoveLocation, setRemoveLocation] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [nonEmergency, setnonEmergency] = useState([]);
    const [nineooemergency, setNineOOEmergency] = useState([]);
    const [displayDropDown, setDisplayDropDown] = useState(1);
    const [nonEmValue, setnonEmValue] = useState(0);
    const [emValue, setEmValue] = useState(0);
    const [nonEmError, setNonEmError] = useState("");
    const [emError, setEmError] = useState("");
    const [Add911Location, setAdd911Location] = useState(false);
    const toggleShow25 = () => setAdd911Location(!Add911Location);
    const [rerender, setReRender] = useState(false);
    const [locationName, setlocationName] = useState("")
    const [isloading, setIsloading] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    console.log("RemoveLocation : " + JSON.stringify(props));
    const addLocRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [locDeleteMessage, setlocDeleteMessage] = useState("");

    function handleClick() {
        addLocRef.current.click();
    }


    const deleteLocation = async () => {
        // if (validateInputs()) {
        console.log("removeLocationId:::::::::" + props.removeLocationId);
        let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;

        let extraURL = "";
        if (displayDropDown === 3) {
            const params = [];
            if (nonEmValue && nonEmValue !== 0) {
                params.push(`transfer_nemg_locid=${nonEmValue}`);
            }
            if (emValue && emValue !== 0) {
                params.push(`transfer_emg_locid=${emValue}`);
            }
            if (params.length > 0) {
                extraURL = `?${params.join('&')}`;
            }
        } else if (displayDropDown === 2) {
            if (nonEmValue && nonEmValue !== 0) {
                extraURL = `?transfer_nemg_locid=${nonEmValue}`;
            }
        }
        setIsloading(true);
        let saverep = await removeUserLocation(siteid, props.removeLocationInfo.location_id, extraURL);
        let saverepeMsg = await saverep.json();
        setIsloading(false);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            localStorage.setItem("s_message", saverepeMsg.message);
            props.onClose();
            await getGlobalLocation();
            if (props.tab === 'tab2') {
                navigate("/LocLanding", { state: { tab: "location", tab1: "tab2" } });
            } else {
                navigate("/LocLanding", { state: { tab: "location", tab1: "tab1" } });
            }
            window.location.reload();
        } else {
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                    if (err.param_name.trim() == 'transfer_nemg_locid') {
                        setNonEmError(err.message);
                    } if (err.param_name.trim() == 'transfer_emg_locid') {
                        setEmError(err.message);
                    }
                });
            }
        }
        // }
    }
    const validateInputs = () => {
        if ((displayDropDown === 2 || displayDropDown === 3) && parseInt(nonEmValue) === 0) {
            setNonEmError("Please select a location for non emergency associations.");
            return false;
        }
        if (displayDropDown === 3 && parseInt(emValue) === 0) {
            setEmError("Please select an emergency 911 location.");
            return false;
        }
        return true;
    }
    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    useEffect(() => {
        if (props.removeLocationInfo && props.removeLocationInfo.location_id && props.removeLocationInfo.location_id != "" || rerender) {
            getDeleteLocationDependency();
            setReRender(false);
        }


    }, [props.removeLocationInfo, rerender]);

    async function getDeleteLocationDependency() {
        setIsloading(true);
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["loc_delete"], loc_id: props.removeLocationInfo.location_id }
        );
        console.log(response);
        setIsloading(false);

        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        } else {
            const tdata = await response.json();
            if (!tdata) {
                window.alert(`info with id  not found`);
                navigate("/");
            }
            console.log("Response Data:", JSON.stringify(tdata));
            if (!rerender) {
                let nonloc = (tdata?.misc?.loc_delete?.non_emergency_assoc ?? []).filter((loc) => parseInt(loc.loc_id) !== parseInt(props.removeLocationInfo.location_id));
                if (nonloc.length > 0) {
                    const jsonnonObj = nonloc.find(item => item.default_loc === true);
                    setnonEmValue(jsonnonObj?.loc_id ?? 0);
                    setnonEmergency(nonloc);
                }
            }
            
            let emgLoc = tdata?.misc?.loc_delete?.emergency_assoc ?? [];
            emgLoc = emgLoc.filter(item => item.loc_id !== props.removeLocationInfo.location_id);
            if (emgLoc.length > 0) {
                if (locationName && locationName.trim() != "") {
                    const jsonObj = emgLoc.find(item => item.loc_name.trim() === locationName.trim());
                    setEmValue(jsonObj?.nineoo_loc_id ?? 0);
                } else {
                    const jsonObj = emgLoc.find(item => item.default_loc === true);
                    setEmValue(jsonObj?.nineoo_loc_id ?? 0);
                }
                setNineOOEmergency(emgLoc);
            }
            setDisplayDropDown(tdata?.misc?.loc_delete?.display_flag ?? 1);
            if (tdata?.misc?.loc_delete?.display_msg) {
                setlocDeleteMessage(tdata?.misc?.loc_delete?.display_msg);
            } else  if(tdata?.misc?.loc_delete?.nineoo_required) {
                setlocDeleteMessage(tdata?.misc?.loc_delete?.nineoo_required);

            }


        }


    }

    return (
        <React.Fragment>
            <>
            {!isloading && (
                <div>
                    {locDeleteMessage && locDeleteMessage !== "" ? (
                        <>
                         <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                                    <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                                     <span >{locDeleteMessage}</span>
                                </div>
                            <MDBModalFooter>

                                <MDBBtn onClick={(e) => props.onClose(e)}> {t("OK")} </MDBBtn>
                            </MDBModalFooter>
                        </>
                    ) : (
                        <>
                            {displayDropDown === 1 && (
                                // <div>
                                //     <span className="phrecording">{t("RemoveLocationtxt")}</span>
                                // </div>
                                <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                                    <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                                    <span>{t("RemoveLocationtxt")}</span>
                                </div>
                            )}
                            {(displayDropDown === 2 || displayDropDown === 3) &&
                                (
                                    <>
                                        {nonEmergency && nonEmergency.length > 0 && (
                                            <>
                                                <div>
                                                    <span className="phrecording">
                                                        {t("Locassociation")}
                                                    </span>
                                                </div>
                                                <div className="tel-numbers mt-3">
                                                    <strong>{t("selectLoctransfer")}</strong>
                                                </div>
                                                <span className="phrecording">
                                                    {t("billingsettings")}
                                                </span>
                                                <div className="w-100 mb-3">
                                                    <select
                                                        className="form-select form-control w-100"
                                                        name="San Jose"
                                                        value={nonEmValue}
                                                        onChange={(e) => {
                                                            e.preventDefault();
                                                            setnonEmValue(e.target.value);
                                                            if (parseInt(e.target.value) !== 0) {
                                                                setNonEmError("");
                                                            }
                                                        }
                                                        }
                                                    >
                                                        <option value={0}>--Select Location--</option>
                                                        {nonEmergency && nonEmergency.map((nonem) => (
                                                            <option value={nonem.loc_id}>{nonem.loc_name}{nonem.default_loc ? '(default)' : ''}</option>
                                                        ))}
                                                    </select>
                                                    {nonEmError && <div style={{ color: 'red' }}>{nonEmError}</div>}
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            {displayDropDown === 3 && (
                                <>
                                    {nineooemergency && nineooemergency.length > 0 && (<>
                                        <div className="tel-numbers mt-1">
                                            <strong>{t("select911loc")}</strong>
                                        </div>
                                        <span className="phrecording">
                                            {t("Search911enloc")}
                                        </span>
                                        <div className="mb-0 w-100">
                                            <div className="w-100">
                                                <select
                                                    className="form-select form-control w-100"
                                                    name="San Jose"
                                                    value={emValue}
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        setEmValue(e.target.value);
                                                        if (parseInt(e.target.value) !== 0) {
                                                            setEmError("");
                                                        }
                                                    }
                                                    }
                                                >
                                                    <option value={0}>--Select Location--</option>
                                                    {nineooemergency && nineooemergency.map((em) => (
                                                        <option value={em.nineoo_loc_id}>{em.loc_name}{em.default_loc ? ' (default)' : ''}</option>
                                                    ))}
                                                </select>
                                                {emError && <div style={{ color: 'red' }}>{emError}</div>}
                                            </div>
                                        </div>

                                        <MDBBtn className="mt-3 ml-0" onClick={toggleShow25}>
                                            <MDBIcon fas icon="plus" size="sm" /> {t("add911onlyloc")}
                                        </MDBBtn>
                                    </>)}
                                </>
                            )}
                            <MDBModalFooter className="p-0 pt-2 mt-3">
                                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                                    {t("close")}
                                </MDBBtn>
                                <MDBBtn disabled={isloading} onClick={() => deleteLocation(props)}> {t("remove")} </MDBBtn>
                            </MDBModalFooter>
                        </>
                    )}


                </div>
                )}
                {Add911Location && (
                    <PopupLoaderNew
                        title={t("Add911Loc")}
                        content={
                            <AddNineOneOneLocation
                                setAcdActive={null}
                                setSuccessMessage={setSuccessMessage}
                                setReRender={setReRender}
                                removeFlag={true}
                                setlocationName={setlocationName}
                                onClose={toggleShow25}
                                ref={addLocRef}
                                setIsloading={setisLoading}

                            />}
                        onShow={setAdd911Location}
                        onClose={toggleShow25}
                        onSave={handleClick}
                        isloading={isLoading}
                        flag={1}
                    />
                )}
                {successMessage && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="success"
                        autohide
                        position="bottom-right"
                        delay={10000}
                    >
                        <i className="fas fa-check-circle me-3"></i>
                        <span className="alert-msg">{successMessage}</span>
                    </MDBAlert>
                )
                }
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
            </>

        </React.Fragment >
    );
}
export default RemoveLocations;

